/**
 * BattleUpdateStageReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * BattleUpdateStageReq
 */
export interface BattleUpdateStageReq {
  /** 对战ID */
  id: string
  /** 对战阶段 */
  stage: string
}

/**
 * BattleUpdateStageReq Schema
 */
export const BattleUpdateStageReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '对战ID',
      format: 'string',
      type: 'string',
      label: '对战ID',
    },
    stage: {
      description: '对战阶段',
      enum: ['preparing', 'battling', 'settling', 'finished'],
      format: 'cons.BattleStage',
      type: 'string',
      label: '对战阶段',
    },
  },
  required: ['id', 'stage'],
  type: 'object',
}
